export class TreeNamedResAndNameUtils {
    private static _subResourceTypeMap: Partial<Record<string, string[]>> = {
        database: ['table', 'relationship']
    };

    public static correctName(parentName: string, newName: string): string {
        if (parentName == null) {
            return newName;
        } else {
            const index = newName.indexOf(`${parentName}$$`);
            if (index === 0) {
                return newName;
            }
            return `${parentName}$$${newName}`;
        }
    }

    public static extractNameAndParentName(namedName: string): {
        name: string,
        parentName: string
    } {
        const [parentName, name] = namedName.split('$$');
        return {
            parentName,
            name
        };
    }

    public static correctResourceTypeAndName(resourceType: string, originalName: string): {
        resourceType: string;
        resourceName: string;
    } {
        const nameObj = TreeNamedResAndNameUtils.extractNameAndParentName(originalName);
        let newType: string = resourceType;
        if (TreeNamedResAndNameUtils._subResourceTypeMap['database'].includes(resourceType)) {
            newType = `databases/${nameObj.parentName}/${resourceType}`;
        }
        return {
            resourceType: newType,
            resourceName: nameObj.name
        };
    }
}
